import React, { FunctionComponent } from 'react';
import { taskSimpleSelectors } from '../../../../../../../app/resource/task-simple/task-simple.selectors';
import { useSelectWithParams } from '../../../../../../../utils/selector.utils';
import { Editor } from './Editor';
import { IDescriptionProps } from './types';

export const Description: FunctionComponent<IDescriptionProps> = ({ taskId }) => {
  const task = useSelectWithParams(taskSimpleSelectors.selectResourceById, taskId ?? '');
  return (
    <div className="row">
      <div className="col-12">
        <h4 className="bold">Description</h4>
        {task ? <Editor task={task} /> : <textarea disabled></textarea>}
      </div>
    </div>
  );
};
